<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span>{{ total }} Partage<span v-if="total > 1">s</span></span>
        </h1>
      </template>
      <template
        slot="before-actions"
        v-if="isPromoteur">
        <router-link
          :to="{name: 'ContactList'}"
          class="page-header-btn is-small is-primary"
          id="contactCreateButton">
          <!--<span class="icon is-medium"><i class="fas fa-plus-circle"></i></span>-->
          <span>Partager contact</span>
        </router-link>
      </template>
      <!-- <a slot="dropdown-content" class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-file-excel"></i></span><span>Exporter données .xls</span>
       </a> -->
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="false"
      :has-left-col-collapse="false"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <div class="">
        <list-top-bar
          :count="count"
          label="partage(s)">
        </list-top-bar>
        <filters-tags
          :has-filter="hasFilter"
          :filters="filters"
          @reset="resetFilters"
          @update="filters = $event; updateSimpleFilter()"></filters-tags>
        <spinner-round
          :is-loading="loading"
          v-if="loading"></spinner-round>
        <div
          v-if="isDistributeur"
          class="notification is-warning is-marginless is-flex is-padding">
          <div class="is-margin-right is-margin-top-xxsmall">
            <span class="icon is-large is-size-"><i class="far fa-2x fa-info-circle"></i></span>
          </div>
          <div>
            <b>informations sur les contact partagés :</b> Un contact partagé est un contact que vous a attribué un autre utilisateur de la plateforme. Le contact partagé reste la propriété de l’utilisateur qui vous l’a partagé.
            Si vous acceptez le ou les contacts, vous accédez à la fiche complète du contact. Vous pouvez compléter les informations, poser des options, rendez-vous, etc, comme avec un de vos contacts.
            Le propriétaire du contact peut à tout moment vous retirer ce contact.
          </div>
        </div>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucun partage disponible
            </h2>
            <a
              class="has-text-primary"
              @click="resetFilters"
              v-if="hasFilter"><span class="icon"><i
                class="fas fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
          </div>
        </div>
        <share-intent-item
          v-for="(item, i) in items"
          :key="item.pk"
          :share-intent="item"
          :class="{'is-margin-top-xxsmall': i > 0}"
          @updateProposal="updateProposal"
          @removeAllShareIntent="removeAllShareIntent"
          @removeShareIntent="removeShareIntent">
        </share-intent-item>
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadItems($event)"></pagination>
      </div>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues, Filter, GenericList, Sort } from '@/mixins'
import ShareIntentItem from './ShareIntentItem'
import { CONTACT_PROPOSAL_STATUS } from '../../mixins/DefaultValues'
import { mapGetters } from 'vuex'

export default {
  name: 'ShareIntentList',
  components: { ShareIntentItem },
  mixins: [GenericList, Sort, DefaultValues, Filter],
  data () {
    return {
      openedCol: false,
      service: 'SHARE_INTENT',
      loading: false,
      loadDocuments: this.loadItems,
      filters: {
        status: []
      },
      initFilters: {
        status: []
      }
    }
  },
  computed: {
    ...mapGetters(['isDistributeur', 'isPromoteur'])
  },
  methods: {
    async updateProposal ({ shareIntentPk, contactPkList, status }) {
      const payload = {
        user: this.currentUser.pk,
        status
      }
      let requests = []
      for (let contactPk of contactPkList) {
        const url = `${this.$resources.SHARE_INTENT}/${shareIntentPk}/${contactPk}`
        requests.push(this.$api.axios.patch(url, payload))
      }
      let message
      if (contactPkList.length === 1) {
        message = status === 'approved' ? 'Contact accepté' : 'Contact refusé'
      } else if (status === CONTACT_PROPOSAL_STATUS.APPROVED) {
        message = `${contactPkList.length} contacts acceptés`
      } else if (status === CONTACT_PROPOSAL_STATUS.REFUSED) {
        message = `${contactPkList.length} contacts refusés`
      }

      let success = false

      try {
        await Promise.allSettled(requests)
        if (message) {
          this.$toasted.global.success(message)
        }
        success = true
      } catch (e) {
        this.$toasted.global.danger('Impossible d\'accepter ce/ces contact(s)')
      }
      if (success) {
        try {
          const { data } = await this.$api.getOne(this.$resources.SHARE_INTENT, shareIntentPk)
          const index = this.items.findIndex(x => x.pk === shareIntentPk)
          this.$set(this.items, index, data)
          this.loadDocuments()
        } catch (error) {
          if (error.response.status === 404) {
            const index = this.items.findIndex(x => x.pk === shareIntentPk)
            this.items.splice(index, 1)
            this.loadDocuments()
          } else {
            this.$toasted.global.danger('Une erreur inattendue s\'est produite, veuillez recharger la page.')
          }
        }
      }
    },
    async removeShareIntent (contactPk, shareIntentPk) {
      try {
        await this.$api.axios.delete(`/share-intents/${shareIntentPk}/${contactPk}`)
        this.loadDocuments()
        this.$toasted.global.success('Proposition de partage annulée')
      } catch (e) {
        this.$toasted.global.danger('Impossible d\'annuler ce partage')
      }
    },
    async removeAllShareIntent ({ shareIntentPk }) {
      try {
        await this.$api.delete(this.$resources.SHARE_INTENT, shareIntentPk)
        const index = this.items.findIndex(x => x.pk === shareIntentPk)
        this.items.splice(index, 1)
        this.loadDocuments()
        this.$toasted.global.success('Proposition de partage annulée')
      } catch (e) {
        this.$toasted.global.danger('Impossible d\'annuler ce partage')
      }
    }
  }
}
</script>

<style scoped>

</style>
